var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tct mb4 bold"},[_vm._v("若需要解除绑定关系可联系客服13356261927")]),(_vm.userInfo.firm_type == 1)?_c('supplier-bind-list'):_c('purchaser-bind-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }